import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { GenericComponentsModule } from '@helios/generic-components'
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { ButtonModule } from '@northfork/ng-basics'
import { ErrorDetailsCardComponent } from './components/error-details-card/error-details-card.component'
import { ErrorLogModalComponent } from './components/error-log-modal/error-log-modal.component'

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    NgbModalModule,
    NgbTooltipModule,
    GenericComponentsModule,
  ],
  declarations: [ErrorLogModalComponent, ErrorDetailsCardComponent],
  exports: [ErrorLogModalComponent],
})
export class ErrorLogModule {}
